<admin-app-header></admin-app-header>

<div class="clusters-page">
    <div class="container-fluid">
        <!-- Page Header -->
        <div class="page-header">
            <h1>Clusters</h1>
            <div class="page-header__actions">
                <button class="btn btn-primary" (click)="createCluster()">
                    <i class="fa-solid fa-plus"></i> New Cluster
                </button>
            </div>
        </div>

        <!-- Summary Stats -->
        <div class="stats-grid">
            <div class="stat-card stat-card--blue">
                <div class="stat-card__icon">
                    <i class="fa-solid fa-layer-group"></i>
                </div>
                <div class="stat-card__content">
                    <span class="stat-card__label">Total Clusters</span>
                    <span class="stat-card__value">{{ clusters.length }}</span>
                </div>
            </div>
            <div class="stat-card stat-card--green">
                <div class="stat-card__icon">
                    <i class="fa-solid fa-square-parking"></i>
                </div>
                <div class="stat-card__content">
                    <span class="stat-card__label">Total Parkings</span>
                    <span class="stat-card__value">{{ getTotalParkings() }}</span>
                </div>
            </div>
        </div>

        <!-- Loading State -->
        <div class="loading-state" *ngIf="loading">
            <i class="fa-solid fa-spinner fa-spin"></i>
            <p>Loading clusters...</p>
        </div>

        <!-- Empty State -->
        <div class="empty-state" *ngIf="!loading && clusters.length === 0">
            <i class="fa-solid fa-layer-group"></i>
            <h3>No clusters yet</h3>
            <p>Create your first cluster to group parkings together for marketing pages.</p>
            <button class="btn btn-primary" (click)="createCluster()">
                <i class="fa-solid fa-plus"></i> Create Cluster
            </button>
        </div>

        <!-- Clusters Table -->
        <div class="table-card" *ngIf="!loading && clusters.length > 0">
            <table class="clusters-table">
                <thead>
                    <tr>
                        <th>Title</th>
                        <th>Description</th>
                        <th>Parkings</th>
                        <th>Created</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let cluster of clusters" 
                        (contextmenu)="onClusterContextMenu($event, cluster)"
                        class="cluster-row"
                        (click)="viewCluster(cluster)">
                        <td>
                            <span class="cluster-title">{{ cluster.title }}</span>
                        </td>
                        <td>
                            <span class="cluster-description" *ngIf="cluster.description">{{ cluster.description | slice:0:50 }}{{ cluster.description.length > 50 ? '...' : '' }}</span>
                            <span class="text-muted" *ngIf="!cluster.description">—</span>
                        </td>
                        <td>
                            <span class="parking-count">{{ cluster.parkingRefs?.length || 0 }}</span>
                        </td>
                        <td>
                            <span class="date-text" *ngIf="cluster.createdAt">{{ cluster.createdAt.toDate() | date: 'mediumDate' }}</span>
                        </td>
                        <td (click)="$event.stopPropagation()">
                            <div class="action-buttons">
                                <button class="action-btn action-btn--edit" (click)="editCluster(cluster)" data-tooltip="Edit">
                                    <i class="fa-solid fa-pen"></i>
                                </button>
                                <button class="action-btn action-btn--view" (click)="viewCluster(cluster)" data-tooltip="View Page">
                                    <i class="fa-solid fa-eye"></i>
                                </button>
                                <button class="action-btn action-btn--copy" (click)="copyClusterLink(cluster)" data-tooltip="Copy Link">
                                    <i class="fa-solid fa-link"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
